import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/Home'
import BuildDevelopment from '@/views/build/Development'
import BuildWhat from '@/views/build/What'
import Connect from '@/views/community/Connect'
import Institute from '@/views/institute/Institute'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/build/development',
      name: 'BuildDevelopment',
      component: BuildDevelopment
    },
    {
      path: '/build/what',
      name: 'BuildWhat',
      component: BuildWhat
    },
    {
      path: '/community/connect',
      name: 'Connect',
      component: Connect
    },
    {
      path: '/institute/aout',
      name: 'Institute',
      component: Institute
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js